import type { Param, RangeParam } from '../types';

export const priceParam: RangeParam = {
  id: 'price',
  type: 'range',
  prefix: '$',
  unit: 'USD',
  label: 'Price',
  group: 'Price',
  help: '$50-200, $-200 or $200 (max), $50- (min). Whole dollars.',
};

export function distanceParam(help: string): Param {
  return {
    id: 'distance',
    type: 'number',
    suffix: 'mi',
    label: 'Within (miles)',
    group: 'Location',
    placeholder: '25',
    help,
  };
}
